import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { css } from '@flipster/styled-system/css';

import { adjustLeverageModalBunja } from '../state';
import { LeverageError } from './leverage-error';
import { LeverageStats } from './leverage-stats';

/** Validation error (if any) + max-position / liq-price stats under the controls. */
export const LeverageFeedback = () => {
  const { errorAtom } = useBunja(adjustLeverageModalBunja);
  const error = useAtomValue(errorAtom);

  return (
    <div className={css({ pt: 12, borderTop: '1px solid', borderColor: 'border.default.level-1' })}>
      {error && <LeverageError message={error.message} action={error.action} />}
      <LeverageStats />
    </div>
  );
};
